import { getQueryParam } from "@/lib/url-helpers"

import router from "@/router"

import EventBus, { EVENTS } from "@/lib/event-bus"

// Stores a block action ID that arrived before BlockActionTrigger.vue was mounted.
// Consumed by the component in its mounted() hook to handle the race condition on
// native iOS where the push handler fires before the Vue component tree is ready.
let pendingBlockAction: string | null = null

export const consumePendingBlockAction = (): string | null => {
  const action = pendingBlockAction
  pendingBlockAction = null
  return action
}

const parseNotificationUrl = (url: string) => {
  const urlObj = url.startsWith("http")
    ? new URL(url)
    : new URL(`https://example.com${url}`)

  const query: Record<string, string> = {}
  urlObj.searchParams.forEach((value, key) => {
    query[key] = value
  })

  return {
    path: urlObj.pathname,
    query,
    hash: urlObj.hash
  }
}

export const handleNotificationUrl = (url: string) => {
  const blockActionQueryParam = getQueryParam(url, "block-action")

  if (blockActionQueryParam) {
    pendingBlockAction = blockActionQueryParam // store for late mounts
    EventBus.$emit(EVENTS.TRIGGER_BLOCK_ACTION, blockActionQueryParam)
  } else {
    const { path, query, hash } = parseNotificationUrl(url)

    const hasQuery = Object.keys(query).length > 0
    if (path === "/" && !hasQuery && !hash) return

    router.push({ path, query, hash })
  }
}
